import { ICellRendererParams } from '@ag-grid-community/core'
import { generateMdiIcon } from '@helios/ag-grid-config'
import { IssueCounts } from '@helios/generic-components'
import { IconClasses } from './account-list-grid-helpers'

export const issueTypeCellRenderer = (params: ICellRendererParams) => {
  if (params.data.accountType === 'aggregate') {
    return ''
  }
  if (params.value === '' || params.value == null) {
    return generateMdiIcon(IconClasses.completed, ['text-success'])
  } else {
    const { found, waiting } = params.value as IssueCounts
    const { count, icon } = (() => {
      if (found?.high?.total)
        return {
          count: found.high.total,
          icon: generateMdiIcon(IconClasses.high, ['text-danger']),
        }
      if (found?.medium?.total)
        return {
          count: found.medium.total,
          icon: generateMdiIcon(IconClasses.medium, ['text-warning']),
        }
      if (waiting?.high || waiting?.medium) {
        return {
          count: (waiting?.high?.total ?? 0) + (waiting?.medium?.total ?? 0),
          icon: generateMdiIcon(IconClasses.waiting),
        }
      }
      return {
        icon: generateMdiIcon(IconClasses.completed, ['text-success']),
        count: undefined,
      }
    })()

    return `${icon} ${count ?? ''}`
  }
}
